import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
import delay from 'lodash/delay';
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-bottom-doodle.svg';
import { SLOW_TIMER } from '~/const/timers';
import { OLAPIC_URL } from '~/const/3rd';
export default {
  props: {
    olapic: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),

  mounted() {
    this.asyncScript(OLAPIC_URL).then(() => {
      delay(this.onOlapicLoad, SLOW_TIMER);
    }).catch(err => {
      console.log(err);
    });
    this.$watch('product', () => {
      this.onOlapicLoad();
    });
  },

  updated() {
    this.onOlapicLoad();
  },

  methods: {
    doRender(options) {
      window.olapic.prepareWidget(options, {
        renderNow: true,
        force: true
      });
    },

    onOlapicLoad() {
      if (window.OlapicSDK) {
        window.OlapicSDK.conf.set('apikey', this.olapic.apikey);
        window.olapic = new window.OlapicSDK.Olapic(o => {
          window.olapic = o;
          this.doRender({
            id: this.olapic.instance,
            wrapper: 'olapic_specific_widget',
            tags: this.olapic.mpnCode,
            lang: "".concat(this.locale.language, "_").concat(this.locale.market),
            useOpi: true
          });
        });
      }
    }

  }
};